// extracted by mini-css-extract-plugin
export default {"container":"Eq-z","heading":"Fq-z","text":"Gq-z","info":"Hq-z","link":"Iq-z","fullMaxWidth":"Jq-z"};